import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import useCustomFecthQuery from "../../../../Hooks/useCustomFecthQuery";
import useCustomMutation from "../../../../Hooks/useCustomMutation";
import ViewAttendee from "./ViewAttendee";
import SendSMSForm from "./SendSMSForm";
import EmailForm from "./EmailForm";
import WhatsAppForm from "./WhatsAppForm";
import ModalDelete from "../../../Modal/ModalDelete";
import DeleteForm from "./DeleteForm";
import OffCanvas from "../../../OffCanvas/OffCanvas";
import { IoEyeOutline } from "react-icons/io5";
import { MdOutlineSms } from "react-icons/md";
import { MdOutlineMailOutline } from "react-icons/md";
import { IoLogoWhatsapp } from "react-icons/io5";
import { FaUserLock } from "react-icons/fa6";
import { MdDelete } from "react-icons/md";
import Tooltip from "../../../../utils/toolTip";

const TableAttendee = ({ token, eventID, search }) => {
  const [attendeeID, setAttendeeID] = useState(null);
  const [attendEmail, setAttendeeEmail] = useState(null);
  const [attendDetails, setAttendeeDetails] = useState(null);
  const [isToggleViewSMS, setIsToggleViewSMS] = useState(false);
  const [isToggleViewEmail, setIsToggleViewEmail] = useState(false);
  const [isToggleViewWhatsApp, setIsToggleViewWhatsApp] = useState(false);
  const [isToggleView, setIsToggleView] = useState(false);
  const [isToggleDelete, setIsToggleDelete] = useState(false);
  const key = ["myAttendees", eventID];

  const mutationDelete = useCustomMutation(key);

  const {
    data: getAttendees,
    error: errorGetAttendees,
    isLoading: isLoadingGeAttendees,
  } = useCustomFecthQuery(
    key,
    `${process.env.REACT_APP_API}attendees/${eventID}/invited`,
    token,
    {
      enabled: !!eventID,
    }
  );

  const tog_viewParticipant = (details) => {
    setAttendeeDetails(details);
    setIsToggleView(!isToggleView);
  };
  
  const tog_sendSMS = (row) => {
    setAttendeeID(row?._id);
    setAttendeeDetails(row);
    setIsToggleViewSMS(!isToggleViewSMS);
  };
  
  const tog_sendEmail = (row) => {
    setAttendeeID(row?._id);
    setAttendeeDetails(row);
    setIsToggleViewEmail(!isToggleViewEmail);
  };
  
  const tog_sendWhatasApp = (row) => {
    setAttendeeID(row?._id);
    setAttendeeDetails(row);
    setIsToggleViewWhatsApp(!isToggleViewWhatsApp);
  };
  
  const tog_deleteParticipant = (id, email) => {
    setAttendeeID(id);
    setAttendeeEmail(email);
    setIsToggleDelete(!isToggleDelete);
  };

  const DeleteParticitant = () => {
    const Method = "DELETE",
      url = `attendees/${attendeeID}/?eventId=${eventID}&email=${attendEmail}`,
      isJSON = null;
    var raw = null;
    const data = {
      endPoint: url,
      bodyContent: raw,
      Method: Method,
      displayMessage: "Attendee successfully deleted",
      token: token,
      isJSON: isJSON,
    };
    mutationDelete.mutate(data);
  };

  const columns = [
    {
      name: <span className="font-weight-bold fs-13">First Name</span>,
      selector: (row) => row?.firstName,
    },
    {
      name: <span className="font-weight-bold fs-13">Last Name</span>,
      selector: (row) => row?.lastName,
    },
    {
      name: <span className="font-weight-bold fs-13">Email</span>,
      selector: (row) => row?.email,
    },
    {
      name: <span className="font-weight-bold fs-13">Phone number</span>,
      selector: (row) => row?.phoneNumber,
    },
    {
      name: <span className="font-weight-bold fs-13">Action</span>,
      cell: (row) => {
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <Tooltip text="View Attendee details">
              <IoEyeOutline
                size={18}
                color="#3b82f6"
                className="mx-1"
                style={{ cursor: "pointer", transition: "all 0.2s" }}
                onClick={() => tog_viewParticipant(row)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </Tooltip>

            <Tooltip text="Send SMS">
              <MdOutlineSms
                size={16}
                color="#f68a20"
                className="mx-1"
                style={{ cursor: "pointer", transition: "all 0.2s" }}
                onClick={() => tog_sendSMS(row)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </Tooltip>

            <Tooltip text="Send Email">
              <MdOutlineMailOutline
                size={16}
                color="#ef4444"
                className="mx-1"
                style={{ cursor: "pointer", transition: "all 0.2s" }}
                onClick={() => tog_sendEmail(row)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </Tooltip>

            <Tooltip text="Send WhatsApp Message">
              <IoLogoWhatsapp
                size={16}
                color="#25D366"
                className="mx-1"
                style={{ cursor: "pointer", transition: "all 0.2s" }}
                onClick={() => tog_sendWhatasApp(row)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </Tooltip>

            <Tooltip text="Suspend Attendee">
              <FaUserLock
                size={14}
                color="#f59e0b"
                className="mx-1"
                style={{ cursor: "pointer", transition: "all 0.2s" }}
                onClick={() => {}}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </Tooltip>

            <Tooltip text="Delete Attendee">
              <MdDelete
                size={16}
                color="#ef4444"
                className="mx-1"
                style={{ cursor: "pointer", transition: "all 0.2s" }}
                onClick={() => tog_deleteParticipant(row?._id, row?.email)}
                onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  // ✅ Simple, robust attendee extraction
  const getAttendeesArray = (response) => {
    if (!response) return [];
    if (Array.isArray(response)) return response;
    if (Array.isArray(response.data)) return response.data;
    return [];
  };

  // ✅ Safe filter function
  const filterParticipants = (participants, searchQuery) => {
    if (!Array.isArray(participants)) return [];
    if (!searchQuery?.trim()) return participants;
    
    const query = searchQuery.toLowerCase();
    return participants.filter((item) =>
      [item?.firstName, item?.lastName, item?.email, item?.jobTitle].some(
        (field) => field?.toLowerCase()?.includes(query)
      )
    );
  };

  // ✅ Extract and prepare data for DataTable
  const attendeesArray = getAttendeesArray(getAttendees);
  const filteredAttendees = filterParticipants(attendeesArray, search);
  const data = Array.isArray(filteredAttendees) ? filteredAttendees : [];

  // ✅ Auto-refresh table after delete
  useEffect(() => {
    if (mutationDelete.isSuccess) {
      setIsToggleDelete(false);
    }
  }, [mutationDelete.isSuccess]);

  // ✅ Debug logging (remove in production if desired)
  useEffect(() => {
    console.log('📊 TableAttendee:', {
      attendeesCount: attendeesArray.length,
      filteredCount: filteredAttendees.length,
      isLoading: isLoadingGeAttendees,
      hasError: !!errorGetAttendees,
    });
  }, [attendeesArray, filteredAttendees, isLoadingGeAttendees, errorGetAttendees]);

  return (
    <div className="mt-3 w-100">
      <div className="analystic-table-card">
        <div className="w-100">
          <DataTable
            fixedHeader
            fixedHeaderScrollHeight="300px"
            columns={columns}
            responsive
            data={data}
            pagination
            progressPending={isLoadingGeAttendees}
            noDataComponent={
              <p className="p-3 text-muted text-center">
                {isLoadingGeAttendees 
                  ? "Loading attendees..." 
                  : search 
                    ? `No results for "${search}"` 
                    : "No attendees found"}
              </p>
            }
          />
        </div>
      </div>
      
      <ModalDelete
        size="md"
        isOpen={isToggleDelete}
        toggle={() => setIsToggleDelete(false)}
        title="Delete Attendee"
        body={
          <DeleteForm
            setIsToggleDelete={setIsToggleDelete}
            DeleteParticitant={DeleteParticitant}
            pending={mutationDelete?.isLoading}
          />
        }
      />
      
      <OffCanvas
        isOffcanvasOpen={isToggleView}
        title="Attendees"
        body={<ViewAttendee details={attendDetails} />}
        toggleSaveChanges={() => tog_viewParticipant()}
        directionOffCanvas="end"
        widthOffCanvas={400}
      />

      <OffCanvas
        isOffcanvasOpen={isToggleViewSMS}
        title="Send SMS"
        body={
          <SendSMSForm
            attendeeID={attendeeID}
            eventID={eventID}
            token={token}
            setIsToggleViewSMS={setIsToggleViewSMS}
            phoneNumber={attendDetails?.phoneNumber}
            attendeeData={attendDetails}
          />
        }
        toggleSaveChanges={() => tog_sendSMS()}
        directionOffCanvas="end"
        widthOffCanvas={400}
      />

      <OffCanvas
        isOffcanvasOpen={isToggleViewEmail}
        title="Send Email"
        body={
          <EmailForm
            attendeeID={attendeeID}
            eventID={eventID}
            token={token}
            setIsToggleViewEmail={setIsToggleViewEmail}
            attendeeData={attendDetails}
          />
        }
        toggleSaveChanges={() => tog_sendEmail()}
        directionOffCanvas="end"
        widthOffCanvas={400}
      />
      
      <OffCanvas
        isOffcanvasOpen={isToggleViewWhatsApp}
        title="Send WhatsApp"
        body={
          <WhatsAppForm
            attendeeID={attendeeID}
            eventID={eventID}
            token={token}
            setIsToggleViewWhatsApp={setIsToggleViewWhatsApp}
            phoneNumber={attendDetails?.phoneNumber}
            attendeeData={attendDetails}
          />
        }
        toggleSaveChanges={() => tog_sendWhatasApp()}
        directionOffCanvas="end"
        widthOffCanvas={400}
      />
    </div>
  );
};

export default TableAttendee;